/*
 * 教室予約カレンダー（段階2：決済まで＋出張リクエスト）
 * 仕様：
 *  - 営業 9:00〜21:00、開始は毎正時、21:00までに終了
 *  - インターバル：:30終了→30分、:00終了→60分（＝占有は必ず正時で終わる）
 *  - 予約受付：前日18時まで。当月＋（15日以降は）翌月
 *  - 時刻は常に日本時間で判定
 *  - 予約内容は注文の「プロパティ」に記録（_ 付きは管理用で、お客様には表示されない）
 *  - 送迎：工房のみ・有料レッスンを含む予約のみ（無料体験のみは不可）。南林間駅⇔工房の往復・無料。開始15分前に集合
 *  - 出張：3時間から。当日と翌日に予定がない日を、第3希望まで選んでリクエスト
 *          （お問い合わせフォームで送信。注文・枠はこの時点では作らない）
 *  - イラスト刺繍コース：3時間・マンツーマン（1名固定）・工房／出張のみ（オンライン不可）
 *          刺繍の種類は商品のバリエーション（シニール刺繍／チェーンステッチ刺繍…）から自動で並ぶ
 */
(function () {
  'use strict';

  var OPEN = 9;
  var CLOSE = 21;
  var CUTOFF_HOUR = 18;
  var NEXT_MONTH_DAY = 15;
  var TRAVEL_MIN = 3;
  var TRAVEL_MAX_DATES = 3;
  var WEEK = ['日', '月', '火', '水', '木', '金', '土'];

  var MENUS = {
    trial:        { label: '無料体験のみ',         sub: '30分',              hours: false, dur: function () { return 30; } },
    paid:         { label: '有料レッスン',         sub: '1時間から',          hours: true,  dur: function (n) { return 60 * n; } },
    trial_paid:   { label: '無料体験＋有料レッスン', sub: '30分＋1時間から',    hours: true,  dur: function (n) { return 30 + 60 * n; } },
    illustration: { label: 'イラスト刺繍コース',     sub: '3時間・中級者以上',   hours: false, dur: function () { return 180; } }
  };
  var PARTICIPANTS = {
    single:       { label: '1名',     sub: '',                  option: '1名' },
    parent_child: { label: '親子2名', sub: 'お子さまは無料',      option: '親子2名' },
    adults2:      { label: '大人2名', sub: '2人目は半額',        option: '大人2名' }
  };
  var LOCATIONS = {
    studio: { label: '工房（座間）', sub: '駐車場1台あり' },
    online: { label: 'オンライン',   sub: 'Google Meet' },
    travel: { label: '出張',         sub: '3時間から・交通費実費' }
  };
  var ACCESS = {
    car:     { label: '車', sub: '駐車場を利用' },
    transit: { label: '公共交通機関・その他', sub: '' },
    pickup:  { label: '南林間駅から送迎', sub: '往復・無料' }
  };
  var ACCESS_TEXT = { car: '車（駐車場を利用）', transit: '公共交通機関・その他', pickup: '南林間駅から送迎（往復）' };
  var TIMEBANDS = { morning: '午前から', afternoon: '午後から', any: 'どちらでも' };

  /* ---------- 日付ユーティリティ ---------- */
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function ymd(y, m, d) { return y + '-' + pad(m) + '-' + pad(d); }
  function addDays(y, m, d, n) {
    var t = new Date(Date.UTC(y, m - 1, d + n));
    return { y: t.getUTCFullYear(), m: t.getUTCMonth() + 1, d: t.getUTCDate() };
  }
  function daysInMonth(y, m) { return new Date(Date.UTC(y, m, 0)).getUTCDate(); }
  function weekday(y, m, d) { return new Date(Date.UTC(y, m - 1, d)).getUTCDay(); }
  function fmt(min) { return Math.floor(min / 60) + ':' + pad(min % 60); }
  function yen(n) { return '¥' + Math.round(n).toLocaleString('ja-JP'); }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function jstNow() {
    var o = {};
    new Intl.DateTimeFormat('en-US', {
      timeZone: 'Asia/Tokyo', year: 'numeric', month: 'numeric', day: 'numeric',
      hour: 'numeric', hourCycle: 'h23'
    }).formatToParts(new Date()).forEach(function (p) { o[p.type] = p.value; });
    return { y: +o.year, m: +o.month, d: +o.day, h: +o.hour };
  }
  function cellsFor(dur) {
    var interval = (dur % 60 === 0) ? 60 : 30;
    return (dur + interval) / 60;
  }
  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function postJSON(url, body) {
    return fetch(root() + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j && (j.description || j.message) || 'カートの更新に失敗しました');
        return j;
      });
    });
  }

  function init(rootEl) {
    var app = rootEl.querySelector('[data-rab-app]');
    var dataEl = rootEl.querySelector('[data-rab-data]');
    var cfgEl = rootEl.querySelector('[data-rab-config]');
    if (!app || !dataEl) return;

    var cfg = { trial: null, paid: {}, illust: {}, pickup: null, pickupPlace: '', pickupMapUrl: '', pickupLead: 15, travelUrl: '', policy: '', parkingNote: '', parkingMapUrl: '' };
    try { cfg = Object.assign(cfg, JSON.parse(cfgEl ? cfgEl.textContent : '{}')); } catch (e) {}

    /* 予約データ → 日付ごとの占有マス */
    var occ = {};
    var raw = [];
    try { raw = JSON.parse(dataEl.textContent || '[]'); } catch (e) { raw = []; }
    raw.forEach(function (r) {
      if (!r || !r.d || typeof r.s !== 'number' || typeof r.e !== 'number') return;
      /* end_date（x）があれば、開始日〜最終日の毎日を同じ時間で埋める（最大400日） */
      var p = r.d.split('-'), y = +p[0], m = +p[1], dd = +p[2];
      for (var i = 0; i < 400; i++) {
        var t = addDays(y, m, dd, i);
        var ds = ymd(t.y, t.m, t.d);
        if (i > 0 && (!r.x || ds > r.x)) break;
        var day = occ[ds] || (occ[ds] = {});
        for (var h = Math.max(r.s, OPEN); h < Math.min(r.e, CLOSE); h++) day[h] = true;
      }
    });

    var menuKeys = ['trial', 'paid', 'trial_paid'];
    if (rootEl.getAttribute('data-show-illustration') === 'true') menuKeys.push('illustration');

    /* 受付期間 */
    var now = jstNow();
    var first = addDays(now.y, now.m, now.d, now.h < CUTOFF_HOUR ? 1 : 2);
    var firstStr = ymd(first.y, first.m, first.d);
    var months = [{ y: now.y, m: now.m }];
    if (now.d >= NEXT_MONTH_DAY) {
      var nx = addDays(now.y, now.m, daysInMonth(now.y, now.m), 1);
      months.push({ y: nx.y, m: nx.m });
    }
    var lastM = months[months.length - 1];
    var lastStr = ymd(lastM.y, lastM.m, daysInMonth(lastM.y, lastM.m));
    var windowText;
    if (months.length > 1) {
      windowText = lastM.m + '月' + daysInMonth(lastM.y, lastM.m) + '日までご予約いただけます。';
    } else {
      var nm = addDays(now.y, now.m, daysInMonth(now.y, now.m), 1);
      windowText = nm.m + '月分のカレンダーは' + now.m + '月' + NEXT_MONTH_DAY + '日に公開されます。';
    }

    var state = {
      menu: 'trial', n: 1, mi: 0, date: null, start: null,
      participants: 'single', location: 'studio', access: null, exp: null, wish: '', kind: null,
      agree: false, busy: false, error: '',
      dates: [], band: null,
      f: { name: '', phone: '', email: '', address: '', machine: '' }
    };
    if (months.length > 1 && (first.y > now.y || first.m > now.m)) state.mi = 1;

    var maxN = { paid: CLOSE - OPEN, trial_paid: CLOSE - OPEN - 1 };

    function isTravel() { return state.location === 'travel'; }
    function minN() { return isTravel() ? TRAVEL_MIN : 1; }
    function dur() { return MENUS[state.menu].dur(state.n); }
    function inWindow(ds) { return ds >= firstStr && ds <= lastStr; }
    function fits(ds, S) {
      var d = dur();
      if (S * 60 + d > CLOSE * 60) return false;
      var day = occ[ds];
      if (!day) return true;
      var end = Math.min(S + cellsFor(d), CLOSE);
      for (var h = S; h < end; h++) if (day[h]) return false;
      return true;
    }
    function starts(ds) {
      var list = [];
      for (var S = OPEN; S * 60 + dur() <= CLOSE * 60; S++) list.push({ S: S, ok: fits(ds, S) });
      return list;
    }
    /* 出張：当日と翌日に予約・ブロックが1つもない日だけ選べる */
    function dayFree(ds) {
      var day = occ[ds];
      if (!day) return true;
      for (var h = OPEN; h < CLOSE; h++) if (day[h]) return false;
      return true;
    }
    function travelOk(ds) {
      var p = ds.split('-');
      var t = addDays(+p[0], +p[1], +p[2], 1);
      return dayFree(ds) && dayFree(ymd(t.y, t.m, t.d));
    }
    function status(ds) {
      if (!inWindow(ds)) return 'off';
      if (isTravel()) return travelOk(ds) ? 'open' : 'full';
      return starts(ds).some(function (x) { return x.ok; }) ? 'open' : 'full';
    }
    function hasTrial() { return state.menu === 'trial' || state.menu === 'trial_paid'; }
    function hasPaid() { return state.menu === 'paid' || state.menu === 'trial_paid'; }
    function paidVariant() { return cfg.paid[PARTICIPANTS[state.participants].option] || null; }
    function isIllust() { return state.menu === 'illustration'; }
    function illustKinds() {
      return Object.keys(cfg.illust || {}).filter(function (k) { return cfg.illust[k].available !== false; });
    }
    function illustVariant() { return (state.kind && cfg.illust[state.kind]) || null; }
    function pickupAllowed() { return state.menu !== 'trial'; }
    function hasPickup() { return state.location === 'studio' && state.access === 'pickup' && pickupAllowed(); }
    function meetText() {
      if (state.start === null) return '開始' + cfg.pickupLead + '分前';
      return fmt(state.start * 60 - cfg.pickupLead);
    }
    function total() {
      var t = 0;
      if (hasPickup() && cfg.pickup) t += cfg.pickup.price / 100;
      if (hasTrial() && cfg.trial) t += cfg.trial.price / 100;
      if (hasPaid() && paidVariant()) t += (paidVariant().price / 100) * state.n;
      if (isIllust() && illustVariant()) t += illustVariant().price / 100;
      return t;
    }
    function feeText() {
      if (isIllust() && !illustVariant()) return 'コース料金＋交通費（実費）';
      return yen(total()) + '＋交通費（実費）';
    }
    function menuText() {
      if (state.menu === 'paid') return '有料レッスン ' + state.n + '時間';
      if (state.menu === 'trial_paid') return '無料体験30分＋有料レッスン' + state.n + '時間';
      if (isIllust() && state.kind) return MENUS.illustration.label + '（' + state.kind + '）';
      return MENUS[state.menu].label;
    }
    function dateText(ds) {
      var p = ds.split('-');
      return (+p[0]) + '年' + (+p[1]) + '月' + (+p[2]) + '日（' + WEEK[weekday(+p[0], +p[1], +p[2])] + '）';
    }
    function missing() {
      var list = [];
      if (isIllust() && !state.kind) list.push('刺繍の種類');
      if (!state.date) list.push('日付');
      if (state.start === null) list.push('開始時刻');
      if (!state.exp) list.push('ミシン経験');
      if (state.location === 'studio' && !state.access) list.push('来場手段');
      if (!state.agree) list.push('キャンセルポリシーへの同意');
      return list;
    }
    /* 出張：ボタンで選ぶ項目 */
    function travelMissing() {
      var list = [];
      if (isIllust() && !state.kind) list.push('刺繍の種類');
      if (!state.dates.length) list.push('第1希望日');
      if (!state.band) list.push('希望の時間帯');
      if (!state.exp) list.push('ミシン経験');
      if (!state.agree) list.push('キャンセルポリシーへの同意');
      return list;
    }
    /* 出張：文字で入力する項目（送信時にチェック） */
    function textMissing() {
      var f = state.f, list = [];
      if (!f.name.trim()) list.push('お名前');
      if (!f.phone.trim()) list.push('電話番号');
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(f.email.trim())) list.push('メールアドレス');
      if (!f.address.trim()) list.push('出張先のご住所');
      if (!f.machine.trim()) list.push('ミシンの機種');
      return list;
    }
    function productsReady() {
      return (!hasTrial() || cfg.trial) && (!hasPaid() || paidVariant()) && (!hasPickup() || cfg.pickup) &&
        (!isIllust() || illustKinds().length > 0);
    }
    function revalidate() {
      /* イラスト刺繍：マンツーマン・オンライン不可 */
      if (isIllust()) {
        state.participants = 'single';
        if (state.location === 'online') state.location = 'studio';
        if (state.exp === 'no') state.exp = null;
        if (state.kind && illustKinds().indexOf(state.kind) === -1) state.kind = null;
      }
      if (isTravel()) {
        if (state.menu === 'trial') state.menu = 'paid';
        if (MENUS[state.menu].hours && state.n < TRAVEL_MIN) state.n = TRAVEL_MIN;
        state.dates = state.dates.filter(function (ds) { return status(ds) === 'open'; });
        state.date = null; state.start = null; state.access = null;
        return;
      }
      if (state.date && status(state.date) !== 'open') state.date = null;
      if (state.date && state.start !== null && !fits(state.date, state.start)) state.start = null;
      if (!state.date) state.start = null;
      if (state.location !== 'studio') state.access = null;
      if (state.access === 'pickup' && !pickupAllowed()) state.access = null;
    }

    /* ---------- 描画 ---------- */
    function optButtons(act, map, current, keys, disabled) {
      var html = '';
      (keys || Object.keys(map)).forEach(function (k) {
        var m = map[k];
        var label = typeof m === 'string' ? m : m.label;
        var sub = typeof m === 'string' ? '' : (m.sub || '');
        var off = disabled && disabled.indexOf(k) !== -1;
        html += '<button type="button" class="rab-opt" data-act="' + act + '" data-v="' + k + '" aria-pressed="' + (current === k) + '"' + (off ? ' disabled' : '') + '>' +
          '<span class="rab-opt__t">' + label + '</span>' + (sub ? '<span class="rab-opt__s">' + sub + '</span>' : '') + '</button>';
      });
      return html;
    }

    function renderMenus() {
      var html = '<div class="rab__menus" role="group" aria-label="メニュー">' +
        optButtons('menu', MENUS, state.menu, menuKeys, isTravel() ? ['trial'] : null) + '</div>';
      if (isTravel()) html += '<p class="rab-field__n">出張レッスンは3時間からです（無料体験のみは選べません）。</p>';
      if (isIllust()) {
        var kinds = {};
        illustKinds().forEach(function (k) {
          var v = cfg.illust[k];
          kinds[k] = { label: esc(k), sub: yen(v.price / 100) + (v.compare > v.price ? '（通常' + yen(v.compare / 100) + '）' : '') };
        });
        html += '<div class="rab-field"><p class="rab-field__l">刺繍の種類</p>' +
          '<div class="rab__menus" role="group" aria-label="刺繍の種類">' + optButtons('kind', kinds, state.kind) + '</div>' +
          '<p class="rab-field__n">基本的なトレース刺繍ができる方が対象の、3時間のマンツーマンレッスンです。材料・下絵・糸はこちらでご用意します（手ぶらでOK）。完成品はお持ち帰りいただけます。オンラインでは受講できません。</p></div>';
      }
      if (MENUS[state.menu].hours) {
        html += '<div class="rab-hours"><span class="rab-hours__l">有料レッスンの時間</span>' +
          '<div class="rab-stepper">' +
          '<button type="button" data-act="dec" aria-label="1時間減らす"' + (state.n <= minN() ? ' disabled' : '') + '>−</button>' +
          '<span class="rab-stepper__v" aria-live="polite">' + state.n + '時間</span>' +
          '<button type="button" data-act="inc" aria-label="1時間増やす"' + (state.n >= maxN[state.menu] ? ' disabled' : '') + '>＋</button>' +
          '</div></div>';
      }
      return html;
    }

    function renderDetails() {
      var html = '<div class="rab-field"><p class="rab-field__l">参加形態</p>';
      if (isIllust()) {
        html += '<p class="rab-field__n">イラスト刺繍コースはマンツーマン（1名）です。</p></div>';
      } else {
        html += '<div class="rab__opts3" role="group" aria-label="参加形態">' + optButtons('participants', PARTICIPANTS, state.participants) + '</div>' +
          '<p class="rab-field__n">2名の場合は、ミシン1台を交代で使い、講師がそばでサポートします。2時間以上がおすすめです。</p></div>';
      }

      html += '<div class="rab-field"><p class="rab-field__l">受講場所</p>' +
        '<div class="rab__opts3" role="group" aria-label="受講場所">' + optButtons('location', LOCATIONS, state.location, null, isIllust() ? ['online'] : null) + '</div>';
      if (isTravel()) {
        html += '<p class="rab-field__n">出張料はいただかず、交通費の実費のみ別途ご請求します。希望日を第3希望までお送りいただき、ご住所を確認のうえ、日程と交通費をご連絡します。' +
          (cfg.travelUrl ? ' <a href="' + esc(cfg.travelUrl) + '" target="_blank" rel="noopener">ご相談はこちら</a>' : '') + '</p>';
      }
      html += '</div>';

      if (state.location === 'studio') {
        html += '<div class="rab-field"><p class="rab-field__l">来場手段</p>' +
          '<div class="rab__opts3" role="group" aria-label="来場手段">' + optButtons('access', ACCESS, state.access, null, pickupAllowed() ? null : ['pickup']) + '</div>' +
          (pickupAllowed() ? '' : '<p class="rab-field__n">南林間駅からの無料送迎は、有料レッスンを含むご予約でご利用いただけます。</p>');
        if (state.access === 'car' && cfg.parkingNote) {
          html += '<p class="rab-note" role="note"><strong>駐車場について</strong>' + esc(cfg.parkingNote) +
            (cfg.parkingMapUrl ? '<a class="rab-note__link" href="' + esc(cfg.parkingMapUrl) + '" target="_blank" rel="noopener">近隣のコインパーキングを地図で見る</a>' : '') +
            '</p>';
        }
        if (state.access === 'pickup') {
          html += '<p class="rab-note" role="note"><strong>送迎について</strong>' +
            '小田急線 南林間駅から工房まで、往復で無料送迎します。<br>' +
            '待ち合わせ：' + esc(cfg.pickupPlace) + '<br>' +
            '集合時間：' + meetText() + (state.start === null ? '' : '（レッスン開始の' + cfg.pickupLead + '分前）') + '<br>' +
            'レッスン後も南林間駅までお送りします。' +
            (cfg.pickupMapUrl ? '<a class="rab-note__link" href="' + esc(cfg.pickupMapUrl) + '" target="_blank" rel="noopener">待ち合わせ場所を地図で見る</a>' : '') +
            '</p>';
        }
        html += '</div>';
      }

      html += '<div class="rab-field"><p class="rab-field__l">ミシン経験</p>' +
        '<div class="rab__menus" role="group" aria-label="ミシン経験">' +
        optButtons('exp', { no: 'はじめて', yes: '経験あり' }, state.exp, null, isIllust() ? ['no'] : null) + '</div>' +
        (isIllust() ? '<p class="rab-field__n">イラスト刺繍コースは、基本的なトレース刺繍ができる方が対象です。はじめての方は「無料体験」または「有料レッスン」からお選びください。</p>' : '') +
        '</div>';

      html += '<div class="rab-field"><label class="rab-field__l" for="rab-wish">習いたいこと（任意）</label>' +
        '<textarea id="rab-wish" class="rab-text" data-input="wish" rows="3" maxlength="300" placeholder="例：ワッペンを作ってみたい、自分のミシンの使い方を知りたい">' + esc(state.wish) + '</textarea></div>';
      return html;
    }

    function renderCalendar() {
      var cur = months[state.mi];
      var travel = isTravel();
      var html = '<p class="rab-window">' + windowText + '</p>';
      if (travel) {
        html += '<p class="rab-field__n">希望日を押した順に第1〜第3希望になります（もう一度押すと解除）。移動があるため、前後に予定がある日は選べません。</p>';
      }
      html += '<div class="rab-cal">' +
        '<div class="rab-cal__head">' +
        '<button type="button" class="rab-cal__nav" data-act="prev" aria-label="前の月"' + (state.mi === 0 ? ' disabled' : '') + '>‹</button>' +
        '<span class="rab-cal__m">' + cur.y + '年' + cur.m + '月</span>' +
        '<button type="button" class="rab-cal__nav" data-act="next" aria-label="次の月"' + (state.mi >= months.length - 1 ? ' disabled' : '') + '>›</button>' +
        '</div><div class="rab-cal__wk">';
      WEEK.forEach(function (w) { html += '<span>' + w + '</span>'; });
      html += '</div><div class="rab-cal__days">';
      var lead = weekday(cur.y, cur.m, 1);
      for (var i = 0; i < lead; i++) html += '<span class="rab-day is-empty" aria-hidden="true"></span>';
      var totalDays = daysInMonth(cur.y, cur.m);
      for (var d = 1; d <= totalDays; d++) {
        var ds = ymd(cur.y, cur.m, d);
        var st = status(ds);
        var rank = travel ? state.dates.indexOf(ds) : -1;
        var sel = travel ? rank !== -1 : state.date === ds;
        var mark = rank !== -1 ? '第' + (rank + 1) : (st === 'open' ? '○' : (st === 'full' ? '×' : ''));
        var label = cur.m + '月' + d + '日 ' +
          (rank !== -1 ? '第' + (rank + 1) + '希望' : (st === 'open' ? (travel ? '希望日に選べます' : '予約できます') : (st === 'full' ? (travel ? '選べません' : '満席') : '受付外')));
        html += '<button type="button" class="rab-day is-' + st + (sel ? ' is-selected' : '') + '" data-act="day" data-v="' + ds + '"' +
          (st !== 'open' ? ' disabled' : '') + ' aria-pressed="' + sel + '" aria-label="' + label + '">' +
          '<span>' + d + '</span><span class="rab-day__mark" aria-hidden="true">' + mark + '</span></button>';
      }
      html += '</div><p class="rab-legend">' +
        (travel ? '<span>○ 希望日に選べます</span><span>× 選べません</span>' : '<span>○ 予約できます</span><span>× 満席</span>') +
        '<span class="rab-legend__off">薄字 受付外</span></p></div>';
      return html;
    }

    function renderSlots() {
      if (!state.date) return '<p class="rab-empty">カレンダーから日付を選んでください。</p>';
      var d = dur();
      var html = '<div class="rab-slots" role="group" aria-label="開始時刻">';
      starts(state.date).forEach(function (x) {
        var sel = state.start === x.S;
        var range = fmt(x.S * 60) + '〜' + fmt(x.S * 60 + d);
        html += '<button type="button" class="rab-slot" data-act="slot" data-v="' + x.S + '"' +
          (x.ok ? '' : ' disabled') + ' aria-pressed="' + sel + '" aria-label="' + range + (x.ok ? '' : ' 空きなし') + '">' +
          '<span class="rab-slot__t">' + fmt(x.S * 60) + '</span>' +
          '<span class="rab-slot__r">' + (x.ok ? '〜' + fmt(x.S * 60 + d) : '空きなし') + '</span></button>';
      });
      return html + '</div>';
    }

    function textField(key, label, type, ph, auto) {
      return '<div class="rab-field"><label class="rab-field__l" for="rab-' + key + '">' + label + '</label>' +
        '<input id="rab-' + key + '" class="rab-text" type="' + type + '" data-input="f.' + key + '" value="' + esc(state.f[key]) + '"' +
        ' placeholder="' + ph + '" autocomplete="' + auto + '"></div>';
    }

    function renderTravelForm() {
      return '<div class="rab-field"><p class="rab-field__l">希望の時間帯</p>' +
        '<div class="rab__opts3" role="group" aria-label="希望の時間帯">' + optButtons('band', TIMEBANDS, state.band) + '</div>' +
        '<p class="rab-field__n">ご都合のよい開始時刻があれば「習いたいこと」の欄にご記入ください。</p></div>' +
        textField('name', 'お名前', 'text', '例：山田 花子', 'name') +
        textField('phone', '電話番号', 'tel', '例：090-1234-5678', 'tel') +
        textField('email', 'メールアドレス', 'email', '例：example@mail.com', 'email') +
        textField('address', '出張先のご住所', 'text', '例：神奈川県〇〇市〇〇町1-2-3', 'street-address') +
        textField('machine', 'ミシンの機種', 'text', '例：メーカー名と型番', 'off');
    }

    function renderSummary() {
      var timeText = (state.start !== null) ? fmt(state.start * 60) + '〜' + fmt(state.start * 60 + dur()) : '未選択';
      var miss = missing();
      var ready = miss.length === 0 && productsReady() && !state.busy;
      var btn = state.busy ? '予約画面へ移動しています…' : (miss.length ? miss[0] + 'を選んでください' : '予約して支払いへ進む');
      if (miss.length && miss[0] === 'キャンセルポリシーへの同意') btn = 'キャンセルポリシーに同意してください';

      var html = '<div class="rab-sum">' +
        '<div class="rab-sum__row"><span>内容</span><strong>' + menuText() + '</strong></div>' +
        '<div class="rab-sum__row"><span>参加</span><strong>' + PARTICIPANTS[state.participants].label + '・' + LOCATIONS[state.location].label + '</strong></div>' +
        '<div class="rab-sum__row"><span>日付</span><strong>' + (state.date ? dateText(state.date) : '未選択') + '</strong></div>' +
        '<div class="rab-sum__row"><span>時間</span><strong>' + timeText + '</strong></div>' +
        (hasPickup() ? '<div class="rab-sum__row"><span>送迎</span><strong>' + meetText() + ' 南林間駅集合（無料）</strong></div>' : '') +
        '<div class="rab-sum__row rab-sum__total"><span>料金（税込）</span><strong>' + yen(total()) + '</strong></div>';

      html += renderPolicy();
      if (!productsReady()) html += '<p class="rab-sum__err">予約用の商品が見つかりません。商品のハンドル設定を確認してください。</p>';
      if (state.error) html += '<p class="rab-sum__err" role="alert">' + esc(state.error) + '</p>';
      html += '<button type="button" class="rab-sum__btn" data-act="submit"' + (ready ? '' : ' disabled') + '>' + btn + '</button>' +
        '<p class="rab-sum__note">お名前・ご連絡先は、次の支払い画面でご入力いただきます。</p></div>';
      return html;
    }

    function renderTravelSummary() {
      var miss = travelMissing();
      var ready = miss.length === 0 && !state.busy;
      var btn = state.busy ? '送信しています…' : (miss.length ? miss[0] + 'を選んでください' : '出張レッスンをリクエストする');
      if (miss.length && miss[0] === 'キャンセルポリシーへの同意') btn = 'キャンセルポリシーに同意してください';

      var dates = state.dates.length
        ? state.dates.map(function (ds, i) { return '第' + (i + 1) + '希望 ' + dateText(ds); }).join('<br>')
        : '未選択';

      var html = '<div class="rab-sum">' +
        '<div class="rab-sum__row"><span>内容</span><strong>' + menuText() + '</strong></div>' +
        '<div class="rab-sum__row"><span>参加</span><strong>' + PARTICIPANTS[state.participants].label + '・出張</strong></div>' +
        '<div class="rab-sum__row"><span>希望日</span><strong class="rab-sum__dates">' + dates + '</strong></div>' +
        '<div class="rab-sum__row"><span>時間帯</span><strong>' + (state.band ? TIMEBANDS[state.band] : '未選択') + '</strong></div>' +
        '<div class="rab-sum__row rab-sum__total"><span>料金の目安（税込）</span><strong>' + feeText() + '</strong></div>';

      html += renderPolicy();
      if (state.error) html += '<p class="rab-sum__err" role="alert">' + esc(state.error) + '</p>';
      html += '<button type="button" class="rab-sum__btn" data-act="submit"' + (ready ? '' : ' disabled') + '>' + btn + '</button>' +
        '<p class="rab-sum__note">この時点ではご予約・お支払いは確定しません。日程と交通費が決まりましたら、お支払いのご案内をメールでお送りします。</p></div>';
      return html;
    }

    function renderPolicy() {
      if (!cfg.policy) return '';
      return '<div class="rab-policy"><p class="rab-policy__t">キャンセルポリシー</p><p>' + esc(cfg.policy) + '</p>' +
        '<label class="rab-check"><input type="checkbox" data-input="agree"' + (state.agree ? ' checked' : '') + '>' +
        '<span>キャンセルポリシーに同意する</span></label></div>';
    }

    function render() {
      var travel = isTravel();
      app.innerHTML =
        '<div class="rab__grid">' +
          '<div class="rab__main">' +
            '<div class="rab__step"><h3 class="rab__step-h"><span class="rab__step-n">1</span>メニューを選ぶ</h3>' + renderMenus() + '</div>' +
            '<div class="rab__step"><h3 class="rab__step-h"><span class="rab__step-n">2</span>受講内容を選ぶ</h3>' + renderDetails() + '</div>' +
            '<div class="rab__step"><h3 class="rab__step-h"><span class="rab__step-n">3</span>' + (travel ? '出張の希望日を選ぶ（第3希望まで）' : '日付を選ぶ') + '</h3>' + renderCalendar() + '</div>' +
          '</div>' +
          '<div class="rab__side">' +
            '<div class="rab__step" data-rab-slots><h3 class="rab__step-h"><span class="rab__step-n">4</span>' + (travel ? '時間帯とご連絡先' : '開始時刻を選ぶ') + '</h3>' +
              (travel ? renderTravelForm() : renderSlots()) + '</div>' +
            (travel ? renderTravelSummary() : renderSummary()) +
          '</div>' +
        '</div>';
    }

    /* ---------- カートへ ---------- */
    function buildItems() {
      var s = state.start;
      var d = dur();
      var shown = {
        '予約日': dateText(state.date),
        '時間': fmt(s * 60) + '〜' + fmt(s * 60 + d),
        '受講場所': LOCATIONS[state.location].label,
        '参加形態': PARTICIPANTS[state.participants].label,
        'ミシン経験': state.exp === 'yes' ? '経験あり' : 'はじめて'
      };
      if (isIllust()) shown['刺繍の種類'] = state.kind;
      if (state.location === 'studio') shown['来場手段'] = ACCESS_TEXT[state.access];
      if (hasPickup()) shown['送迎'] = fmt(s * 60 - cfg.pickupLead) + ' ' + cfg.pickupPlace + ' 集合';
      if (state.wish.trim()) shown['習いたいこと'] = state.wish.trim();

      var meta = {
        '_rab': '1',
        '_rab_primary': '1',
        '_date': state.date,
        '_start_hour': String(s),
        '_end_hour': String(s + cellsFor(d)),
        '_menu': state.menu,
        '_paid_hours': hasPaid() ? String(state.n) : '0',
        '_participants': state.participants,
        '_location': state.location
      };

      var items = [];
      if (isIllust()) {
        items.push({ id: illustVariant().id, quantity: 1, properties: Object.assign({}, shown, meta) });
      }
      if (hasTrial()) {
        items.push({ id: cfg.trial.id, quantity: 1, properties: Object.assign({}, shown, meta) });
      }
      if (hasPaid()) {
        var props = items.length
          ? { '予約日': shown['予約日'], '時間': shown['時間'], '_rab': '1' }
          : Object.assign({}, shown, meta);
        items.push({ id: paidVariant().id, quantity: state.n, properties: props });
      }
      if (hasPickup()) {
        items.push({ id: cfg.pickup.id, quantity: 1, properties: {
          '予約日': shown['予約日'], '時間': shown['時間'], '送迎': shown['送迎'], '_rab': '1'
        } });
      }
      return items;
    }

    function submit() {
      if (missing().length || !productsReady() || state.busy) return;
      /* 送信直前にも空きを再確認 */
      if (!fits(state.date, state.start) || !inWindow(state.date)) {
        state.start = null; state.error = 'この時間は選べなくなりました。別の時間を選んでください。';
        render(); return;
      }
      state.busy = true; state.error = ''; render();

      fetch(root() + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          /* 以前に入れた予約があれば外す（二重予約防止） */
          var updates = {};
          (cart.items || []).forEach(function (it) {
            if (it.properties && it.properties._rab) updates[it.key] = 0;
          });
          return Object.keys(updates).length ? postJSON('cart/update.js', { updates: updates }) : null;
        })
        .then(function () { return postJSON('cart/add.js', { items: buildItems() }); })
        .then(function () { window.location.href = root() + 'checkout'; })
        .catch(function (err) {
          state.busy = false;
          state.error = '予約をカートに追加できませんでした。時間をおいて再度お試しください。（' + err.message + '）';
          render();
        });
    }

    /* ---------- 出張リクエスト（お問い合わせフォームで送信） ---------- */
    function travelSubmit() {
      if (travelMissing().length || state.busy) return;
      var tm = textMissing();
      if (tm.length) { state.error = tm.join('・') + 'をご入力ください。'; render(); return; }

      var before = state.dates.length;
      state.dates = state.dates.filter(travelOk);
      if (state.dates.length !== before) {
        state.error = '選べなくなった希望日があったため外しました。希望日をご確認ください。';
        render(); return;
      }

      var form = rootEl.querySelector('[data-rab-travel] form');
      if (!form) { state.error = '送信フォームが見つかりません。時間をおいて再度お試しください。'; render(); return; }

      var f = state.f;
      var fields = {
        'contact[name]': f.name.trim(),
        'contact[email]': f.email.trim(),
        'contact[phone]': f.phone.trim(),
        'contact[種別]': '出張レッスンのリクエスト',
        'contact[第1希望]': dateText(state.dates[0]),
        'contact[第2希望]': state.dates[1] ? dateText(state.dates[1]) : 'なし',
        'contact[第3希望]': state.dates[2] ? dateText(state.dates[2]) : 'なし',
        'contact[希望の時間帯]': TIMEBANDS[state.band],
        'contact[メニュー]': menuText(),
        'contact[刺繍の種類]': isIllust() ? state.kind : '—',
        'contact[参加形態]': PARTICIPANTS[state.participants].label,
        'contact[ミシン経験]': state.exp === 'yes' ? '経験あり' : 'はじめて',
        'contact[出張先の住所]': f.address.trim(),
        'contact[ミシンの機種]': f.machine.trim(),
        'contact[料金の目安]': feeText(),
        'contact[body]': state.wish.trim() || '（記入なし）'
      };

      Array.prototype.forEach.call(form.querySelectorAll('[data-rab-gen]'), function (el) { el.remove(); });
      Object.keys(fields).forEach(function (name) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = fields[name];
        input.setAttribute('data-rab-gen', '1');
        form.appendChild(input);
      });

      state.busy = true; state.error = ''; render();

      /* Shopify公式の方法：ロボット確認（hCaptcha）の準備ができてから送信する */
      var timer = setTimeout(function () {
        state.busy = false;
        state.error = '送信に時間がかかっています。通信環境をご確認のうえ、もう一度お試しください。';
        render();
      }, 20000);
      window.addEventListener('pagehide', function () { clearTimeout(timer); }, { once: true });

      if (window.Shopify && window.Shopify.captcha && typeof window.Shopify.captcha.protect === 'function') {
        window.Shopify.captcha.protect(form, function () { form.submit(); });
      } else {
        form.submit();
      }
    }

    /* ---------- 操作 ---------- */
    app.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-act]');
      if (!b || b.disabled) return;
      var act = b.getAttribute('data-act');
      var v = b.getAttribute('data-v');
      var pickedDay = false;

      if (act === 'submit') { if (isTravel()) travelSubmit(); else submit(); return; }
      if (act === 'day' && isTravel()) {
        var idx = state.dates.indexOf(v);
        if (idx !== -1) state.dates.splice(idx, 1);
        else if (state.dates.length >= TRAVEL_MAX_DATES) {
          state.error = '希望日は第3希望まで選べます。どれかを解除してから選び直してください。';
          render(); return;
        } else state.dates.push(v);
      }
      else if (act === 'menu') { state.menu = v; if (!MENUS[v].hours) state.n = 1; }
      else if (act === 'dec') { state.n = Math.max(minN(), state.n - 1); }
      else if (act === 'inc') { state.n = Math.min(maxN[state.menu] || 1, state.n + 1); }
      else if (act === 'prev') { state.mi = Math.max(0, state.mi - 1); }
      else if (act === 'next') { state.mi = Math.min(months.length - 1, state.mi + 1); }
      else if (act === 'day') { state.date = v; state.start = null; pickedDay = true; }
      else if (act === 'slot') { state.start = +v; }
      else if (act === 'participants') { state.participants = v; }
      else if (act === 'location') { state.location = v; }
      else if (act === 'access') { state.access = v; }
      else if (act === 'exp') { state.exp = v; }
      else if (act === 'band') { state.band = v; }
      else if (act === 'kind') { state.kind = v; }

      state.error = '';
      revalidate();
      render();

      if (pickedDay && window.matchMedia('(max-width: 899px)').matches) {
        var target = app.querySelector('[data-rab-slots]');
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (target) target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      }
    });

    /* 文字入力は再描画しない（入力中のカーソルを保つ） */
    app.addEventListener('input', function (e) {
      var key = e.target.getAttribute('data-input');
      if (key === 'wish') state.wish = e.target.value;
      else if (key && key.indexOf('f.') === 0) state.f[key.slice(2)] = e.target.value;
    });
    app.addEventListener('change', function (e) {
      if (e.target.getAttribute('data-input') === 'agree') { state.agree = e.target.checked; render(); }
    });

    render();

    /* 出張リクエスト送信後は、結果メッセージまでスクロール */
    var posted = rootEl.querySelector('[data-rab-posted]');
    if (posted) posted.scrollIntoView({ block: 'center' });
  }

  function boot() {
    document.querySelectorAll('[data-rab-root]').forEach(function (el) {
      if (el.getAttribute('data-rab-ready')) return;
      el.setAttribute('data-rab-ready', '1');
      init(el);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
